export default __webpack_public_path__ + "media/nextjs.be0601bc.png";